import React from "react";


function BasketCount(props) {
  return (
  <>{props.basketCount === 1 ? `${props.basketCount} item`:`${props.basketCount} items`}</>
  );
}

export default BasketCount;